import { Info } from 'components/common/form/modules/Info';
import { API_ENDPOINTS, fetchAPI } from 'components/graphql/FetchApi'
import {
    getInventoryItemsAsString,
    updateSellInventoryItem
} from 'components/graphql/queries'
import { openModal } from 'components/modal/modules/dispatcher/methods';

import QRCode from 'qrcode.react';

import React, { useCallback, useEffect, useState } from 'react'
import Moment from 'react-moment'
import { connect } from 'react-redux';
import { ClipLoader } from 'react-spinners';
import UserDucks from 'stores/ducks/User.duck';

import {
    Card,
    DropdownItem,
    DropdownMenu,
    DropdownToggle,
    UncontrolledDropdown,
} from 'reactstrap';
import AffiliatesModal from './AffiliatesModal';
import CreateInventoryModal from './CreateInventory.modal';
import PassOnInventoryModal from './PassOnInventory.modal';
// import SharedByModal from './SharedByModal';
import UpdateInventoryModal from './UpdateInventory.modal';

import { ResponsiveScatterPlot } from '@nivo/scatterplot'

const InventoryTable: React.FC<{ [label: string]: any }> = (props: any) => {

    if (props.user.id === '') {
        return null;
    }

    const [height] = useState(props.floorplan ? props.floorplan.height : 10)
    const [campaignId] = useState(props.campaignId)
    const [loading, setLoading] = useState(true)
    const [inventory, setInventory] = useState([{ name: '', id: '' }])
    const usersInit: string[] = []
    const [users, setUsers] = useState(usersInit)
    const [userObjects, setUserObjects] = useState<any[]>([])

    const [selectedUserName, setSelectedUserName] = useState(props.selectedUserName)
    const [imageHeight, setImageHeight] = useState(0)

    const onImgLoad = useCallback(({ target: img }) => {
        setImageHeight(img.offsetHeight)
    }, [setImageHeight])

    const [data, setData] = useState([])

    useEffect(() => {
        fetchAPI
            .post(API_ENDPOINTS.BASE_URL, {
                query: getInventoryItemsAsString,
                variables: {
                    campaignId,
                    sellerId: props.user.isAdmin ? props.createdBy : props.user.id
                }
            })
            .then(res => {
                const int = JSON.parse(res.data.data.inventoryItem.getInventoryAsString)
                setInventory(int)
                const u: string[] = []
                const uObjects: string[] = []
                int.map((item: any) => {
                    item.sharedBy.map((i: any) => {
                        if (u.find((o) => {
                            return i.username === o
                        }) === undefined) {
                            u.push(i.username)
                            uObjects.push(i)
                        }
                    })
                })
                setUsers(u)
                setUserObjects(uObjects)
                if (props.floorplan) {
                    const initData: any = [];
                    props.floorplan.labels.map((item: any) => {
                        initData.push({
                            id: item.label,
                            data: [{ x: item.x, y: item.y }]
                        })
                    })
                    // const sold: any[] = []
                    int.map((item: any) => {
                        const d: any = []
                        props.floorplan.inventoryMap.map((i: any) => {
                            if (item.id.toString().trim() === i.inventoryItemId.toString().trim()) {
                                if (i.bought) {
                                    initData.push({
                                        id: item.name + '-' + i.buyerName + '-' + i.x.toString() + i.y.toString(),
                                        data: [{
                                            x: i.x, y: i.y
                                        }]
                                    })
                                } else {
                                    d.push({
                                        x: i.x, y: i.y
                                    })
                                }
                            }
                        })
                        initData.push({
                            id: item.name,
                            data: d
                        })
                    })
                    setData(initData)
                }
                setLoading(false)
            })
            .catch(err => {
                console.log(err)
            })

    }, [setLoading, campaignId, props.user, setInventory, props.createdBy, setUsers, setData, props.floorplan, props.key, selectedUserName, props.createdByUsername])

    const openLinkAsQRCode = useCallback((link: any) => {
        const content = <div style={{ textAlign: 'center' }}>
            <QRCode
                renderAs="svg"
                value={link}
                size={250}
            />
        </div>
        openModal(content, "SCAN QR CODE TO VIEW SALES PAGE", [])
    }, [])

    const openPassOnInventoryModal = useCallback(() => {
        const content = <PassOnInventoryModal
            campaignId={campaignId}
            reloadData={() => props.reloadData()}
            createdBy={props.createdBy}
            currentAffiliates={userObjects}
            inventory={inventory}
        />
        openModal(content, "SHARE TICKETS WITH AFFILIATES", [])
    }, [campaignId, props.reloadData, props.createdBy, inventory, userObjects])

    const openNewLinkModal = useCallback(() => {
        const name = props.user.isAdmin ? props.createdByUsername : props.user.username
        const id = props.user.isAdmin ? props.createdBy : props.user.id
        const links = userObjects.filter((u: any) => {
            return u.email && u.email.includes(name + "-additional-link")
        })
        const email = name + "-additional-link-" + (links.length.toString()) + '-' + id + "@isotope-referral-code.com"
        const content = <PassOnInventoryModal
            campaignId={campaignId}
            reloadData={() => props.reloadData()}
            createdBy={props.createdBy}
            inventory={inventory}
            email={email}
        />
        openModal(content, "NEW SALES LINK", [])
    }, [campaignId, props.reloadData, props.createdBy,
        inventory, userObjects, props.user, selectedUserName,
        props.createdByUsername])

    const handleSellChange = useCallback((inventoryItemId, sell) => {
        fetchAPI
            .post(API_ENDPOINTS.BASE_URL, {
                query: updateSellInventoryItem,
                variables: {
                    inventoryItemId,
                    campaignId,
                    newSell: sell,
                    sellerId: props.user.isAdmin ? props.createdBy : props.user.id
                }
            })
            .then(res => {
                if (res.data.data.inventoryItem.updateSell) {
                    props.reloadData()
                }
            })
    }, [props.reloadData, campaignId, props.user, props.createdBy])

    const openInventoryCreationModal = useCallback(() => {
        const content = <CreateInventoryModal
            campaignId={campaignId}
            reloadData={() => props.reloadData()}
            isHost={props.isHost}
            createdBy={props.createdBy}
            startTime={props.startTime}
            endTime={props.endTime}
            floorplan={props.floorplan}
            fpBackground={props.fpBackground}
            inventory={inventory}
            currentAffiliates={userObjects}
        />
        openModal(content, "NEW TICKET", [])
    }, [inventory, campaignId, userObjects,
        props.isHost,
        props.reloadData, props.createdBy, props.startTime,
        props.endTime, props.floorplan, props.fpBackground])

    const openInventoryUpdateModal = useCallback((item) => {
        const passOnProps = {
            ...item,
            startTime: item.startTime ? item.startTime : props.startTime,
            endTime: item.endTime ? item.endTime : props.endTime
        }

        const sharedInventory: any[] = []

        const inventoryItem: any = inventory.find(x => x.id === item.id)

        inventoryItem.sharedBy.map((i: any) => {
            sharedInventory.push({
                ...i,
                commission: i.commission / 100,
                maxCommission: i.maxCommission / 100,
                inventoryItemPrice: inventoryItem.price / 100
            })
        })

        const content = <UpdateInventoryModal
            inventoryItemId={item.id}
            campaignId={campaignId}
            reloadData={() => props.reloadData()}
            floorplan={props.floorplan}
            createdBy={props.createdBy}
            fpBackground={props.fpBackground}
            inventory={inventory}
            sharedInventory={sharedInventory}
            isHost={props.isHost}
            {...passOnProps}
        />
        openModal(content, "UPDATE TICKET", [])
    }, [inventory, campaignId, props.reloadData, props.floorplan, props.isHost,
        props.endTime, props.startTime, props.fpBackground, props.createdBy])

    const openAllocateTicketsModal = useCallback((uName) => {
        const content = <PassOnInventoryModal
            campaignId={campaignId}
            reloadData={() => props.reloadData()}
            createdBy={props.createdBy}
            inventory={inventory}
            email={uName}
        />
        const ownerName: any = props.user.isAdmin || props.createdBy.toString().trim() === props.user.id
            ? props.createdByUsername
            : props.user.username
        openModal(content, ("SHARE ADDITIONAL TICKETS WITH " + (selectedUserName === ownerName ? "My Primary Link" : (
            selectedUserName.includes(ownerName + "-additional-link-") ?
                ("My #" + (Number(selectedUserName.split('-')[3]) + 2).toString() + " Link") : selectedUserName
        ))), [])
    }, [campaignId, props.reloadData, props.createdBy, inventory, userObjects, props.user, selectedUserName, props.createdByUsername])

    // const sharedByInventoryModal = useCallback((inventoryId) => {

    //     const sharedInventory: any[] = []

    //     const inventoryItem: any = inventory.find((item) => {
    //         return item.id === inventoryId
    //     })
    //     inventoryItem.sharedBy.map((i: any) => {
    //         sharedInventory.push({
    //             ...i,
    //             commission: i.commission / 100,
    //             maxCommission: i.maxCommission / 100,
    //             inventoryItemPrice: inventoryItem.price / 100
    //         })
    //     })

    //     openModal(<SharedByModal
    //         reloadData={() => props.reloadData()}
    //         sharedInventory={sharedInventory}
    //         campaignId={campaignId}
    //         createdBy={props.createdBy}
    //         inventoryItemId={inventoryItem.id}
    //     />, inventoryItem.name, [])

    // }, [props.reloadData, inventory, campaignId, props.createdBy])

    const getDescription = useCallback((node: any) => {

        let content = <div />

        const item: any = inventory.find((i: any) => {
            return i.name.toString().trim() === node.data.serieId.toString().trim()
        })

        const inventoryMapItem: any = props.floorplan ? props.floorplan.inventoryMap.find((i: any) => {
            return i.x === node.data.x && i.y === node.data.y
        }) : null

        let bidExists = false;
        let currBidLabel = 0;
        if (inventoryMapItem) {
            if (inventoryMapItem.bid && !inventoryMapItem.bought) {
                bidExists = true
                currBidLabel = inventoryMapItem.bid.currentBid
            }
        }
        if (item) {
            content = <div>
                {
                    item.name
                }
                <br />
                {
                    bidExists ?
                        'Bid $' + (currBidLabel / 100).toFixed(2)
                        : '$' + (item.price / 100).toFixed(2)
                }
                <br />
                {item.description}
            </div>
        } else {
            content = <div>
                <div>
                    {node.data.serieId.split('-')[0]}
                </div>
                <div>
                    {node.data.serieId.split('-')[1]}
                </div>
            </div>
        }
        return <div
            className='blur-safari'
            style={{
                padding: '10px',
                color: '#242d51',
                borderRadius: '15px',
                backdropFilter: 'blur(20px)',
                border: '0.4px solid #f1f1f1',
                boxShadow: '0 1px 3px rgba(0, 0, 0, 0.02), 0 1px 3px rgba(0, 0, 0, 0.02)'
            }}
        >
            {content}
        </div>
    }, [inventory, props.floorplan])

    const CustomNode = useCallback(({
        node,
        x,
        y,
        size,
        color,
        blendMode,
        onMouseEnter,
        onMouseMove,
        onMouseLeave,
        onClick,
    }) => {
        const label: any = props.floorplan ? props.floorplan.labels.find((i: any) => {
            return i.label.toString().trim() === node.data.serieId.toString().trim()
        }) : null

        const inventoryItem: any = inventory.find((item: any) => {
            return item.name.toString().trim() === node.data.serieId.toString().trim()
        })

        if (!label) {
            return (
                <g transform={`translate(${x},${y})`} style={{ zIndex: 15000000, opacity: 1 }}>
                    <circle
                        stroke={inventoryItem ? "#242d51" : '#f1f1f1'}
                        stroke-width="0.5"
                        fill-opacity={0.4}
                        stroke-opacity={0.75}
                        r={size * 0.5}
                        fill={inventoryItem ? '#f1f1f1' : '#242d51'}
                        style={{ mixBlendMode: blendMode, zIndex: 15000000, opacity: 1 }}
                        onMouseEnter={onMouseEnter}
                        onMouseMove={onMouseMove}
                        onMouseLeave={onMouseLeave}
                        onClick={onClick}
                    />
                </g>
            )
        }
        return (
            <g transform={`translate(${x},${y})`} style={{ zIndex: 15000000, opacity: 1 }}>
                <text
                    x={size * -1}
                    y={size * 0.5}
                    font-size='8px'
                    font-style='bold'
                    color='#1931b9'
                    font-color='#1931b9'
                    style={{ zIndex: 150, opacity: 1 }}
                >
                    {label.label.toUpperCase()}
                </text>
            </g>
        )
    }, [props.floorplan, inventory])

    const username: any = props.user.isAdmin || props.createdBy.toString().trim() === props.user.id
        ? props.createdByUsername
        : props.user.username

    const usersIncludingCurrentUser = [username]
    users.map((u: any) => {
        usersIncludingCurrentUser.push(u)
    })
    const affiliates = users.map((item, ind) => {
        if (!item.includes(username + "-additional-link-")) {
            return <DropdownItem key={ind} onClick={() => {
                setSelectedUserName(item)
                props.setSelectedUserName(item)
            }}>
                {item}
            </DropdownItem>
        }
    })
    const linkUsers = usersIncludingCurrentUser.filter((item) => {
        return (item === username || item.includes(username + "-additional-link-"))
    })
    const yourLinks = linkUsers.map((item, index) => {
        return <DropdownItem
            style={{ color: index === 0 ? '#1931b9' : '#242d51' }}
            key={index} onClick={() => {
                setSelectedUserName(item)
                props.setSelectedUserName(username) // different links have same sales statistics cause same user
            }}>
            {index === 0 ? 'My Primary Link' : ('My #' + (index + 1).toString() + ' Link')}
        </DropdownItem>
    })

    let salesLink = selectedUserName === props.createdByUsername ?
        'https://' + props.subdomain + '.isotopeticketing.com' :
        'https://' + props.subdomain + '.isotopeticketing.com' + '/' + selectedUserName

    const url = window.location.href.toLowerCase();
    const urlItems = url.split('/')
    const subdomain = urlItems[2].split('.')[0]
    if (subdomain === 'localhost:3000') {
        salesLink = selectedUserName === props.createdByUsername ?
            ('http://localhost:3000/sell/' + props.subdomain) :
            ('http://localhost:3000/sell/' + props.subdomain + '/' + selectedUserName)
    } else if (subdomain === 'test') {
        salesLink = selectedUserName === props.createdByUsername ?
            ('https://test.isotopeticketing.com/sell/' + props.subdomain) :
            ('https://test.isotopeticketing.com/sell/' + props.subdomain + '/' + selectedUserName)
    }

    if (loading) {
        return <div style={{ width: '100%', justifyContent: 'center', display: 'flex' }}>
            <div className="p-4 w-100 text-center">
                <ClipLoader color={"#000000"} loading={true} />
            </div>
        </div>
    }

    const sharedWithAffiliate: any[] = []
    inventory.map((item: any) => {
        item.sharedBy.map((i: any) => {
            if (i.username.toString().trim() === selectedUserName.toString().trim()) {
                sharedWithAffiliate.push({
                    ...i,
                    commission: i.commission / 100,
                    maxCommission: i.maxCommission / 100,
                    inventoryItemId: item.id,
                    inventoryItemName: item.name,
                    inventoryItemPrice: item.price / 100
                })
            }
        })
    })


    const isInSalesPeriod = (item: any): boolean => {
        const n = new Date()
        return n >= convertToDate(item.startTime) && n <= convertToDate(item.endTime)
    }

    const convertToDate = (time: any): Date => {
        return new Date(
            time.year,
            time.month - 1,
            time.day,
            time.PM ? time.hour + 12 : time.hour,
            time.minute
        )
    }

    return <div>
        <Card style={{ paddingTop: '20px', paddingBottom: '20px' }}>
            <p style={{ textAlign: 'left', width: '100%', paddingLeft: '20px', paddingRight: '20px', flexDirection: 'row', display: 'flex' }}>
                <div style={{ display: 'flex', flexDirection: screen.width < 800 ? 'column' : 'row', flex: 1 }}>
                    <div style={{ flex: 1, flexDirection: screen.width < 800 ? 'column' : 'row', display: 'flex' }}>
                        <div style={{ float: 'left', width: 'auto' }}>
                            <p style={{ textAlign: 'left', width: 'auto' }}>
                                &nbsp;&nbsp;
                                <a href={salesLink} target='_blank' style={{ color: props.isActive ? '#1931b9' : '#565e81', textDecoration: 'underline' }}>
                                    Sales link,
                                </a>
                                &nbsp;
                                <span
                                    onClick={() => {
                                        if (!props.isActive) {
                                            return
                                        }
                                        openLinkAsQRCode(salesLink)
                                    }}
                                    style={{
                                        color: props.isActive ? '#1931b9' : '#565e81',
                                        textDecoration: 'line',
                                        cursor: 'pointer'
                                    }}>
                                    QR code
                                </span>
                                &nbsp;
                            </p>
                        </div>
                        <div style={{ display: 'flex', flexDirection: 'row' }}>
                            <span>
                                &nbsp;and tickets for
                            </span>
                            <span>
                                <UncontrolledDropdown style={{ paddingLeft: '10px', marginTop: '-4px' }}>
                                    <DropdownToggle
                                        className='new-button-white-4'
                                        data-toggle="dropdown"
                                        tag='button'
                                    >
                                        {selectedUserName === username ? "My Primary Link" : (
                                            selectedUserName.includes(username + "-additional-link-") ?
                                                ("My #" + (Number(selectedUserName.split('-')[3]) + 2).toString() + " Link") : selectedUserName
                                        )}  ▼
                                    </DropdownToggle>
                                    <DropdownMenu style={{ borderRadius: '10px' }}>
                                        <DropdownItem header={true}>Your Links</DropdownItem>
                                        {yourLinks}
                                        <DropdownItem header={true}>Team Member</DropdownItem>
                                        {affiliates}
                                    </DropdownMenu>
                                </UncontrolledDropdown>
                            </span>
                        </div>
                    </div>
                    <div style={{ paddingTop: screen.width < 768 ? 30 : 0, float: 'right' }}>
                        {
                            props.isActive ? (
                                (selectedUserName === props.createdByUsername || (selectedUserName === props.user.username)) ?
                                    <span style={{ flex: 1 }}>
                                        <button className='new-button-cancel' onClick={() => openNewLinkModal()} style={{ marginTop: '3px', paddingLeft: '20px' }}>New Link</button>
                                        {
                                            props.user.id === props.createdBy || props.user.isAdmin || props.isHost ?
                                                <button className='new-button-cancel' onClick={() => openInventoryCreationModal()} style={{ marginTop: '3px', paddingLeft: '20px' }}>New Ticket</button>
                                                : null
                                        }
                                        {
                                            props.maxLevels ? null
                                                :
                                                <button
                                                    className='new-button-cancel'
                                                    onClick={() => openPassOnInventoryModal()}
                                                    style={{ marginTop: '3px', paddingLeft: '20px' }}
                                                >
                                                    Share With Affiliates
                                                </button>
                                        }
                                    </span> :
                                    <span style={{ flex: 1 }}>
                                        {
                                            props.maxLevels ? null
                                                : <button className='new-button-cancel' onClick={() => openAllocateTicketsModal(selectedUserName)} style={{ marginTop: '3px', paddingLeft: '20px' }}>Share Additional Tickets</button>
                                        }
                                    </span>
                            )
                                : null
                        }
                    </div>
                </div>
            </p>
            {
                (selectedUserName !== props.user.username && !props.user.isAdmin) || (props.user.isAdmin && selectedUserName !== props.createdByUsername) ?
                    <AffiliatesModal
                        reloadData={() => props.reloadData()}
                        sharedInventory={sharedWithAffiliate}
                        campaignId={campaignId}
                        createdBy={props.createdBy}
                        username={selectedUserName}
                    /> :
                    <div style={{
                        overflow: "scroll", paddingTop: '10px', // maxHeight: '550px'
                    }}>
                        {
                            inventory.length > 0 ?
                                <table className='table-responsive--base m-0' style={{ minWidth: '375px', textAlign: 'left', fontSize: '12px' }}>
                                    <thead>
                                        <tr style={{ alignContent: 'center', height: 'auto', padding: '3px' }}>
                                            <td>TICKET</td>
                                            <td>PRICE</td>
                                            <td>SALES</td>
                                            <td>QTY</td>
                                            {
                                                props.user.id === props.createdBy || props.user.isAdmin ?
                                                    null
                                                    : <td>SHARED BY</td>
                                            }
                                            <td>HIDE</td>
                                        </tr>
                                    </thead>
                                    <tbody style={{ fontSize: '12px' }}>
                                        {
                                            inventory.map((item: any, index: number) => {

                                                let fpObj: any = null;
                                                if (props.floorplan) {
                                                    fpObj = props.floorplan.inventoryMap.find((i: any) => {
                                                        return i.inventoryItemId.toString().trim() === item.id.toString().trim()
                                                    })
                                                }
                                                return <tr key={index} style={{
                                                    cursor: props.user.id === props.createdBy || props.user.isAdmin || props.isHost ? 'pointer' : 'inherit'
                                                }}>
                                                    <td onClick={() => {
                                                        // if (props.user.id === props.createdBy || props.user.isAdmin) {
                                                        openInventoryUpdateModal(item)
                                                        // }
                                                    }}>
                                                        <div className='sexyBlack' >
                                                            {item.name}
                                                        </div>
                                                        <div style={{ fontSize: '11px', wordWrap: 'break-word' }}>
                                                            {item.description && item.description.length > 50
                                                                ? item.description.substr(0, 49) + ' . . .'
                                                                : ''}
                                                        </div>
                                                        {
                                                            item.autoSale || item.endTime ?
                                                                <div style={{ fontSize: '10px', color: isInSalesPeriod(item) ? 'blue' : '#ff69b4' }}>
                                                                    {
                                                                        item.autoSale ?
                                                                            <>
                                                                                <Moment format="D MMM 'YY, " >
                                                                                    {Number(new Date(
                                                                                        item.startTime.year,
                                                                                        item.startTime.month - 1,
                                                                                        item.startTime.day,
                                                                                        (item.startTime.PM ? item.startTime.hour + 12 : item.startTime.hour),
                                                                                        item.startTime.minute
                                                                                    ))}
                                                                                </Moment>
                                                                                <Moment format="hh:mm A">
                                                                                    {Number(new Date(
                                                                                        item.startTime.year,
                                                                                        item.startTime.month - 1,
                                                                                        item.startTime.day,
                                                                                        (item.startTime.PM ? item.startTime.hour + 12 : item.startTime.hour),
                                                                                        item.startTime.minute
                                                                                    ))}
                                                                                </Moment>
                                                                                <br />To<br />
                                                                            </> : null
                                                                    }
                                                                    {
                                                                        item.endTime && !item.autoSale ?
                                                                            <div>
                                                                                Bidding Ends
                                                                            </div> : null
                                                                    }
                                                                    <Moment format="D MMM 'YY, ">
                                                                        {Number(new Date(
                                                                            item.endTime.year,
                                                                            item.endTime.month - 1,
                                                                            item.endTime.day,
                                                                            (item.endTime.PM ? item.endTime.hour + 12 : item.endTime.hour),
                                                                            item.endTime.minute
                                                                        ))}
                                                                    </Moment>
                                                                    <Moment format="hh:mm A">
                                                                        {Number(new Date(
                                                                            item.endTime.year,
                                                                            item.endTime.month - 1,
                                                                            item.endTime.day,
                                                                            (item.endTime.PM ? item.endTime.hour + 12 : item.endTime.hour),
                                                                            item.endTime.minute
                                                                        ))}
                                                                    </Moment>
                                                                </div> : null
                                                        }
                                                    </td>
                                                    <td onClick={() => {
                                                        // if (props.user.id === props.createdBy || props.user.isAdmin) {
                                                        openInventoryUpdateModal(item)
                                                        // }
                                                    }}>
                                                        <div className='sexyBlack'>
                                                            ${(item.price / 100).toFixed(2)}
                                                        </div>
                                                        <div style={{ fontSize: '11px' }}>
                                                            {
                                                                fpObj && fpObj.bid ?
                                                                    <Info>
                                                                        Minimum Bid
                                                                    </Info>
                                                                    :
                                                                    <Info>
                                                                        You earn  ${
                                                                            props.user.isAdmin || props.user.id === props.createdBy ?
                                                                                (item.price / 100).toFixed(2)
                                                                                : (item.commission / 100).toFixed(2)
                                                                        }
                                                                    </Info>
                                                            }
                                                        </div>
                                                    </td>
                                                    <td onClick={() => {
                                                        // if (props.user.id === props.createdBy || props.user.isAdmin) {
                                                        openInventoryUpdateModal(item)
                                                        // }
                                                    }}>{item.bought}</td>
                                                    <td onClick={() => {
                                                        // if (props.user.id === props.createdBy || props.user.isAdmin) {
                                                        openInventoryUpdateModal(item)
                                                        // }
                                                    }}>{item.quantity}</td>
                                                    {
                                                        props.user.id === props.createdBy || props.user.isAdmin ?
                                                            null
                                                            : <td>{item.allocatedBy}</td>
                                                    }
                                                    <td>
                                                        <input
                                                            type="checkbox"
                                                            checked={!item.sell}
                                                            onChange={e => handleSellChange(item.id, !item.sell)}
                                                            style={{ height: '10px', width: '10px' }}
                                                        />
                                                    </td>
                                                    {/* <td>
                                                        <button onClick={() => sharedByInventoryModal(item.id)}>
                                                            SHARED WITH  ▼
                                                        </button>
                                                    </td> */}
                                                </tr>
                                            })
                                        }
                                    </tbody>
                                </table>
                                :
                                <p style={{ width: '100%', textAlign: 'center' }}>
                                    No tickets available
                                </p>
                        }
                        {
                            inventory.length > 0 && (props.isHost || props.user.isAdmin || props.createdBy.toString().trim() === props.user.id.toString().trim())
                                ? <div style={{ marginLeft: '20px', marginTop: '10px' }}>
                                    <Info >
                                        Click on a ticket to edit it.
                                    </Info>
                                </div>
                                : null
                        }
                    </div>
            }
        </Card >
        {
            props.floorplan ?
                <Card style={{ marginTop: '25px', padding: '20px', paddingBottom: props.fpBackground && props.fpBackground !== '' ? imageHeight + 25 : height * 26 }}>
                    <h6 style={{ textAlign: 'left', width: '100%', paddingBottom: '10px' }}>
                        SEATING LAYOUT
                    </h6>
                    <div style={{ position: 'relative', marginTop: '10px' }}>
                        <div style={{ position: 'absolute', width: '100%', textAlign: 'center' }}>
                            {
                                props.fpBackground ?
                                    <img src={props.fpBackground && props.fpBackground !== '' ? props.fpBackground : undefined}
                                        style={{
                                            width: '100%', opacity: 0.75, zIndex: 30, borderRadius: '10px',
                                            maxWidth: '100%'
                                        }}
                                        onLoad={e => onImgLoad(e)}
                                    />
                                    : null
                            }
                        </div>
                        <div style={{
                            position: 'absolute',
                            height: props.fpBackground && props.fpBackground !== '' ?
                                (screen.width >= 768 ? imageHeight - 25 : imageHeight - 12) : height * 25,
                            width: '100%', opacity: 1, zIndex: 35,
                            display: 'flex',
                            justifyContent: 'center',
                            zoom: 100 / 92,
                        }}>
                            <div style={{
                                height: props.fpBackground && props.fpBackground !== '' ? (
                                    screen.width >= 768 ? imageHeight - 25 : imageHeight - 12
                                ) : height * 25, width: '100%'
                            }}>
                                <ResponsiveScatterPlot
                                    data={data}
                                    margin={{
                                        top: screen.width >= 768 ? 20 : 15,
                                        bottom: screen.width >= 768 ? 20 : 15,
                                        left: screen.width >= 768 ? 20 : 15,
                                        right: screen.width >= 768 ? 20 : 15
                                    }}
                                    enableGridX={false}
                                    enableGridY={false}
                                    xScale={{ type: 'linear', min: 0, max: props.floorplan ? props.floorplan.width - 1 : 10 }}
                                    yScale={{ type: 'linear', min: 0, max: props.floorplan ? props.floorplan.height - 1 : 10 }}
                                    axisTop={null}
                                    axisRight={null}
                                    axisLeft={null}
                                    axisBottom={null}
                                    colors={{ scheme: 'paired' }}
                                    tooltip={({ node }: any) => getDescription(node)}
                                    renderNode={CustomNode}
                                />
                            </div>
                        </div>
                    </div>
                </Card>
                : null
        }
    </div>
}

const mapStateToProps = state => ({
    user: UserDucks.getUser(state),
});

export default connect(mapStateToProps)(InventoryTable);


// WEBPACK FOOTER //
// ./src/pages/campaign/CampaignsDashboard/InventoryTable.tsx